// ABOUTME: Context provider for celebration components
// ABOUTME: Wraps app to provide celebration triggers throughout component tree

import { createContext, type ReactNode, useContext } from 'react'
import { AchievementToast, LevelUpCelebration, XPGainIndicator } from '@/components/celebrations'
import { useCelebrations } from '@/hooks/useCelebrations'

type CelebrationContextType = ReturnType<typeof useCelebrations>

const CelebrationContext = createContext<CelebrationContextType | null>(null)

export function useCelebrationContext() {
  const context = useContext(CelebrationContext)
  if (!context) {
    throw new Error('useCelebrationContext must be used within CelebrationProvider')
  }
  return context
}

interface CelebrationProviderProps {
  children: ReactNode
}

export function CelebrationProvider({ children }: CelebrationProviderProps) {
  const celebrations = useCelebrations()

  return (
    <CelebrationContext.Provider value={celebrations}>
      {children}

      {/* Celebration Overlays */}
      <LevelUpCelebration
        level={celebrations.levelUp.level}
        isActive={celebrations.levelUp.isActive}
        onComplete={celebrations.dismissLevelUp}
        xpGained={celebrations.levelUp.xpGained}
      />

      <AchievementToast
        title={celebrations.achievement.title}
        description={celebrations.achievement.description}
        isActive={celebrations.achievement.isActive}
        onComplete={celebrations.dismissAchievement}
      />

      <XPGainIndicator gains={celebrations.xpGains} onGainComplete={celebrations.removeXPGain} />
    </CelebrationContext.Provider>
  )
}
